import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from '../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view04ImageOptions } from './views/exterior_view04'

class X40BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleBathingPlatformChange = this.handleBathingPlatformChange.bind(this);
    }

    handleBathingPlatformChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BathingPlatform = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view04ImageOptions;

        let image = (
            <TransomConfigurator name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.110364, 0.033307, 0, -0.000066,
                    0.036765, 0.260747, 0, 0.000131,
                    0, 0, 1, 0,
                    249, 136, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        if (this.props.configuration.BathingPlatform.value !== 1) {
            image = <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />;
        }

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans
                        defaults='The X4<sup>0</sup> features an optional bathing platform which is operated electrically, integrated attachment for “hang on” bathing ladder with {{wood}} steps.'
                        values={{ wood: (this.props.configuration.Deck.value === 1) ? ' teak' : 'flexiteek' }}
                     /></p>

                    <RadioGroup label={this.props.t("Bathing platform:")} options={this.props.bathingPlatformOptions} value={this.props.configuration.BathingPlatform} onChange={this.handleBathingPlatformChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40BathingPlatform);


// WEBPACK FOOTER //
// ./src/X40/X40BathingPlatform.js